import React, { useState, useEffect, useMemo } from 'react';
import Swal from 'sweetalert2';
import './SorteoExpress.css';
//import RuletaNumero from './ruletacandado';

const SorteoExpress = ({ dataInfo }) => {
  const [numeros, setNumeros] = useState(dataInfo.data.sorteo.arryPuestos);
  const [sorteo, setSorteo] = useState({});
  const [totalPremio, setTotalPremio] = useState(dataInfo.data.sorteo.premioBase);
  const [seleccionados, setSeleccionados] = useState([]);
  const [cantidadAleatoria, setCantidadAleatoria] = useState(1);
  const [timecero, setTimecero] = useState(dataInfo.data.sorteo.listo);
  const [start, setStart] = useState(false);
  const [finish, setFinish] = useState(false);
  const [winningNumbers, setWinningNumbers] = useState([0, 0]);
  const [reset, setReset] = useState(false);

  

  const actualizarSeleccionados = (arryPuestos, seleccionados) => {
    const nuevosSeleccionados = seleccionados.filter((numero) => {
      const puesto = arryPuestos.find((obj) => Object.keys(obj)[0] === numero);
      return puesto && Object.values(puesto)[0] === ''; // Solo mantener si el puesto está vacío
    });
    return nuevosSeleccionados;
  };

  useEffect(() => {
    const posicion = dataInfo.data.dataSorteos.findIndex(
      (obj) => obj.id === dataInfo.data.sorteo.id
    );
    setSorteo(dataInfo.data.dataSorteos[posicion]);
    setNumeros(dataInfo.data.dataSorteos[posicion].arryPuestos);
    setTotalPremio(dataInfo.data.dataSorteos[posicion].premioBase);
    setTimecero(dataInfo.data.dataSorteos[posicion].listo)
    const nuevosSeleccionados = actualizarSeleccionados(
      dataInfo.data.dataSorteos[posicion].arryPuestos,
      seleccionados
    );
    setSeleccionados(nuevosSeleccionados);

    if (dataInfo.data.dataSorteos[posicion].ganador) {
      function numberToArray(num) {
        return num.toString().split('').map(Number);
      }
      const digitos = numberToArray(dataInfo.data.dataSorteos[posicion].ganador);
      setWinningNumbers(digitos);
      if (!finish) {
        setStart(true);
      }
    }
  }, [dataInfo.data.dataSorteos]);

  const seleccionarNumerosAleatorios = (cantidad) => {
    const disponibles = numeros
      .filter((n) => Object.values(n)[0] === '') // Filtrar números sin comprador
      .map((n) => Object.keys(n)[0]); // Obtener solo las llaves (números)

    if (disponibles.length < cantidad) {
      Swal.fire({
        title: 'Error',
        text: 'No hay suficientes números disponibles.',
        icon: 'error',
      });
      return;
    }

    const seleccionadosAleatorios = [];
    for (let i = 0; i < cantidad; i++) {
      const randomIndex = Math.floor(Math.random() * disponibles.length);
      seleccionadosAleatorios.push(disponibles[randomIndex]);
      disponibles.splice(randomIndex, 1); // Eliminar el número seleccionado de disponibles
    }

    setSeleccionados((prevSeleccionados) => [...prevSeleccionados, ...seleccionadosAleatorios]);
  };

  const toggleNumero = (numero) => {
    if (timecero) {
      reset
        ? Swal.fire('La seleccion de número se reiniciará en unos minutos')
        : Swal.fire('La selección de números está bloqueada faltando menos de 5 minutos para iniciar el sorteo.');
      return;
    }
    const isSelected = seleccionados.includes(numero);
    if (!isSelected) {
      setSeleccionados([...seleccionados, numero]);
    } else {
      setSeleccionados(seleccionados.filter((num) => num !== numero));
    }
  };

  const confirmarPago = () => {
    if (seleccionados.length === 0) {
      Swal.fire('Por favor, seleccione al menos un número.');
      return;
    }

    Swal.fire({
      title: 'Ingrese su nombre para confirmar la compra',
      input: 'text',
      inputPlaceholder: 'Nombre del participante',
      showCancelButton: true,
      confirmButtonText: 'Confirmar Pago',
      cancelButtonText: 'Cancelar',
      preConfirm: (nombre) => {
        if (!nombre) {
          Swal.showValidationMessage('Debe ingresar un nombre');
        }
        return nombre;
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const nombre = result.value;
        Swal.fire({
          title: 'Confirmar Pago',
          text: `El monto de ${pagoTotal.toLocaleString('es-ES')} será descontado. ¿Desea continuar?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, continuar',
          cancelButtonText: 'No, cancelar',
        }).then((confirmResult) => {
          if (confirmResult.isConfirmed) {
            dataInfo.socket.emit('confirmarPago', {
              id: dataInfo.data.sorteo.id,
              seleccionados: seleccionados,
              uid: nombre, 
              admin: true
            });
            
          }
        });
      }
    });
  };

  const pagoTotal = useMemo(() => seleccionados.length * dataInfo.data.sorteo.valor, [seleccionados]);

  return (
    <div className="sorteo-container">
      <h1 className="titulo-blanco">Sorteo MEGALOTO Express</h1>
      <h2 className="titulo-blanco">Premio actual: ${totalPremio}</h2>
      <p className="descripcion titulo-blanco">
        A continuación, selecciona los números disponibles para el sorteo Express
        con un acumulado de <strong>${totalPremio}</strong>. Cada número tiene un valor
        de <strong>${dataInfo.data.sorteo.valor.toLocaleString('es-ES')}</strong>.
      </p>

      {!timecero ? (
        <div className="aleatorio-container">
          <label htmlFor="cantidadAleatoria">Seleccionar números aleatorios: </label>
          <input
            className="input"
            type="number"
            id="cantidadAleatoria"
            min="1"
            max={numeros.filter((n) => Object.values(n)[0] === '').length}
            value={cantidadAleatoria}
            onChange={(e) => setCantidadAleatoria(Number(e.target.value))}
          />
          <button className="seleccionar-aleatorios" onClick={() => seleccionarNumerosAleatorios(cantidadAleatoria)}>
            Seleccionar Aleatoriamente
          </button>
        </div>
      ) : (
        <div className="aleatorio-container">
          <label htmlFor="cantidadAleatoria">Ruleta de Numeros</label>
          {/* <div className="ruleta-container">
            {winningNumbers.map((num, index) => (
              <RuletaNumero key={index} targetNumber={num} delay={index * 10000} start={start} finish={setFinish} />
            ))}
          </div> */}
        </div>
      )}

      <div className="numeros-container">
        {numeros.map((n) => {
          const numeroKey = Object.keys(n)[0];
          const comprador = n[numeroKey];
          return (
            <Numero
              key={numeroKey}
              numero={numeroKey}
              comprador={comprador}
              toggleNumero={toggleNumero}
              seleccionado={seleccionados.includes(numeroKey)}
            />
          );
        })}
      </div>

      <div className="seleccionados">
        <h2 className="titulo-blanco">
          {seleccionados.length} número(s) seleccionado(s). Pago total: <span>${pagoTotal.toLocaleString('es-ES')}</span>
        </h2>
        {seleccionados.length > 0 ? (
          <ul>
            {seleccionados.map((num) => (
              <li key={num} className="seleccionado-numero" onClick={() => toggleNumero(num)}>
                {num}
              </li>
            ))}
          </ul>
        ) : (
          <p className="titulo-blanco">No hay números seleccionados.</p>
        )}
        <button className="confirmar-pago" onClick={confirmarPago}>
          Confirmar Pago
        </button>
      </div>
    </div>
  );
};
const Numero = ({ numero, comprador, toggleNumero, seleccionado, dataInfo }) => {
  let mio = false;
  // if (comprador) {
  //   if (comprador === dataInfo.data.dataUser.uid) {
  //     mio = true;
  //   }
  //   const posicion = dataInfo.data.dataUsers.findIndex(
  //     (obj) => obj.id === comprador
  //   );
  //   if(posicion!=-1){
  //     comprador = dataInfo.data.dataUsers[posicion].nombre;
  //   }
  // }

  return (
    <div
      className={`numero ${comprador ? 'ocupado' : 'disponible'} ${seleccionado ? 'seleccionado' : ''} ${mio ? 'mio' : ''}`}
      onClick={() => !comprador && toggleNumero(numero)}
    >
      <span>{numero}</span>
      {comprador && (
        <div className="tooltip">Comprado por: {comprador}</div>
      )}
    </div>
  );
};

export default SorteoExpress;
